import { Card } from '@/shared/components/ui/card';

interface SectionCardProps {
  title: string;
  icon: React.ReactNode;
  children: React.ReactNode;
}

export function SectionCard({ title, icon, children }: SectionCardProps) {
  return (
    <Card className="flex flex-col gap-4">
      <div className="flex items-center gap-2 pb-3 border-b border-outline">
        <span className="text-primary opacity-60">{icon}</span>
        <h3 className="text-light text-sm font-semibold uppercase tracking-wider">{title}</h3>
      </div>
      {children}
    </Card>
  );
}
